import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}
function TermsContent() {
  return <>
      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-56">
        1. Aceptación de los Términos
      </h4>
      <p className="mb-5" data-id="element-57">
        Al acceder y utilizar este sitio web, usted acepta estar sujeto a estos
        Términos y Condiciones de uso, todas las leyes y regulaciones
        aplicables, y acepta que es responsable del cumplimiento de las leyes
        locales aplicables.
      </p>

      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-58">
        2. Propiedad Intelectual
      </h4>
      <p className="mb-5" data-id="element-59">
        Todo el contenido incluido en este sitio, como texto, gráficos,
        logotipos, imágenes, clips de audio, descargas digitales y compilaciones
        de datos, es propiedad de la empresa o de sus proveedores de contenido y
        está protegido por las leyes de propiedad intelectual internacionales.
      </p>

      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-60">
        3. Uso de la Licencia
      </h4>
      <p className="mb-5" data-id="element-61">
        Se concede permiso para descargar temporalmente una copia de los
        materiales (información o software) en este sitio web solo para
        visualización transitoria personal y no comercial.
      </p>

      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-62">
        4. Limitación de Responsabilidad
      </h4>
      <p className="mb-5" data-id="element-63">
        En ningún caso la empresa o sus proveedores serán responsables de ningún
        daño (incluyendo, sin limitación, daños por pérdida de datos o
        beneficios, o debido a la interrupción del negocio) que surja del uso o
        la incapacidad de usar los materiales en este sitio web.
      </p>

      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-64">
        5. Modificaciones
      </h4>
      <p data-id="element-65">
        Podemos revisar estos términos de servicio para su sitio web en
        cualquier momento sin previo aviso. Al utilizar este sitio web, usted
        acepta estar sujeto a la versión actual de estos Términos y Condiciones.
      </p>
    </>;
}
function PrivacyContent() {
  return <>
      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-66">
        1. Recopilación de Información
      </h4>
      <p className="mb-5" data-id="element-67">
        Recopilamos información cuando usted se registra en nuestro sitio,
        realiza un pedido, se suscribe a nuestro boletín o completa un
        formulario. La información recopilada incluye su nombre, dirección de
        correo electrónico y número de teléfono.
      </p>

      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-68">
        2. Uso de la Información
      </h4>
      <p className="mb-5" data-id="element-69">
        Cualquier información que recopilemos de usted puede ser utilizada para
        personalizar su experiencia, mejorar nuestro sitio web, mejorar el
        servicio al cliente y procesar transacciones.
      </p>

      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-70">
        3. Protección de la Información
      </h4>
      <p className="mb-5" data-id="element-71">
        Implementamos una variedad de medidas de seguridad para mantener la
        seguridad de su información personal cuando realiza un pedido o ingresa,
        envía o accede a su información personal.
      </p>

      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-72">
        4. Uso de Cookies
      </h4>
      <p className="mb-5" data-id="element-73">
        Nuestras cookies mejoran el acceso a nuestro sitio e identifican a los
        visitantes frecuentes. Además, nuestras cookies mejoran la experiencia
        del usuario al rastrear y dirigir sus intereses. Sin embargo, este uso
        de cookies no está vinculado de ninguna manera a ninguna información de
        identificación personal en nuestro sitio.
      </p>

      <h4 className="text-lg font-bold text-brand-navy mb-3" data-id="element-74">
        5. Consentimiento
      </h4>
      <p data-id="element-75">
        Al utilizar nuestro sitio, usted acepta nuestra política de privacidad.
      </p>
    </>;
}
function Modal({
  isOpen,
  onClose,
  title
}: ModalProps) {
  return <AnimatePresence data-id="element-76">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-brand-navy/80 backdrop-blur-sm z-50" data-id="element-77" />
          <div className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none" data-id="element-78">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col pointer-events-auto overflow-hidden" data-id="element-79">
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-80">
                <h3 className="text-2xl font-serif font-bold text-brand-navy" data-id="element-81">
                  {title}
                </h3>
                <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-82">
                  <XIcon className="w-5 h-5" data-id="element-83" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto text-gray-600 leading-relaxed" data-id="element-84">
                {title === 'Términos y Condiciones' ? <TermsContent data-id="element-85" /> : <PrivacyContent data-id="element-86" />}
              </div>
              <div className="p-6 border-t border-gray-100 bg-gray-50 flex justify-end" data-id="element-87">
                <button onClick={onClose} className="px-6 py-2 bg-brand-navy text-white rounded-lg font-medium hover:bg-brand-navy/90 transition-colors" data-id="element-88">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}
export function Footer() {
  const [modalConfig, setModalConfig] = useState<{
    isOpen: boolean;
    title: string;
  }>({
    isOpen: false,
    title: ''
  });
  const openModal = (title: string) => {
    setModalConfig({
      isOpen: true,
      title
    });
  };
  const closeModal = () => {
    setModalConfig(prev => ({
      ...prev,
      isOpen: false
    }));
  };
  return <footer className="bg-[#0f172a] text-gray-400 py-12 px-4" data-id="element-89">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-90">
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-6 text-sm" data-id="element-91">
          <button onClick={() => openModal('Términos y Condiciones')} className="hover:text-white transition-colors" data-id="element-92">
            Términos y Condiciones
          </button>
          <span className="hidden md:inline text-gray-600" data-id="element-93">|</span>
          <button onClick={() => openModal('Política de Privacidad')} className="hover:text-white transition-colors" data-id="element-94">
            Política de Privacidad
          </button>
        </div>
        <p className="text-sm" data-id="element-95">© 2026 Todos los derechos reservados.</p>
      </div>

      <Modal isOpen={modalConfig.isOpen} onClose={closeModal} title={modalConfig.title} data-id="element-96" />
    </footer>;
}